<body>
  <section class="banner">
    <div class="container">
      <div class="row justify-content-between align-items-center">
        <div class="col-lg-3 col-md-4">
          <div class="logo">
            <img
              src="{{
                onPassiveBaseUrl
              }}onpassive(jan-23)/images/logo.png"
              alt="logo"
              class="img-fluid"
            />
          </div>
        </div>
        <div class="col-lg-6 col-md-7">
          <div class="social-icon text-center text-md-right">
            <ul>
              <li>
                <a
                  href="https://onpassive.com/blog"
                  target="_blank"
                  rel="noopener"
                  class="icons"
                  ><img
                    src="{{ onPassiveBaseUrl }}onpassive(jan-23)/images/s1.png"
                    alt="s1"
                    class="img-fluid"
                /></a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/ONPASSIVE/ONPASSIVE"
                  target="_blank"
                  rel="noopener"
                  class="icons"
                  ><img
                    src="{{ onPassiveBaseUrl }}onpassive(jan-23)/images/s2.png"
                    alt="s2"
                    class="img-fluid"
                /></a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/ONPASSIVE/"
                  target="_blank"
                  rel="noopener"
                  class="icons"
                  ><img
                    src="{{ onPassiveBaseUrl }}onpassive(jan-23)/images/s3.png"
                    alt="s3"
                    class="img-fluid"
                /></a>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/c/ONPASSIVEc/ONPASSIVE"
                  target="_blank"
                  rel="noopener"
                  class="icons"
                  ><img
                    src="{{ onPassiveBaseUrl }}onpassive(jan-23)/images/s4.png"
                    alt="s4"
                    class="img-fluid"
                /></a>
              </li>
              <li>
                <a
                  href="https://twitter.com/ONPASSIVE"
                  target="_blank"
                  rel="noopener"
                  class="icons"
                  ><img
                    src="{{ onPassiveBaseUrl }}onpassive(jan-23)/images/s5.png"
                    alt="s5"
                    class="img-fluid"
                /></a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/company/onpassiveofficial/company/onpassiveofficial"
                  target="_blank"
                  rel="noopener"
                  class="icons"
                  ><img
                    src="{{ onPassiveBaseUrl }}onpassive(jan-23)/images/s6.png"
                    alt="s6"
                    class="img-fluid"
                /></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row align-items-center after-content">
        <div class="col-lg-4 col-md-5">
          <div class="banner-content">
            <h1>Path-breaking Online Business Solution</h1>
            <a
              href="/registration/user?reg={{ userId }}"
              name="regform"
              target="_blank"
              rel="noopener"
              class="btn btn-danger"
              >Become A Founder</a
            >
          </div>
        </div>
        <div class="col-md-3">
          <div class="play-icon text-center">
            <!-- <a href="javascript:void(0)"
              ><img
                src="{{
                  onPassiveBaseUrl
                }}onpassive(jan-23)/images/play-icon.png"
                alt="play-icon"
                class="img-fluid"
            /></a> -->
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="feature-video">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-11">
          <h2 class="text-center">
            Witness the Perfect Amalgamation of <br />
            Artificial Intelligence with Human Capabilities
          </h2>
          <p>
            If you are looking for an impeccable platform to transform your
            business into online phenomena, then your hunt stops here. We
            understand the dynamics of every business need and offer an
            outstanding online solution integrated with Artificial Intelligence
            to deliver expected results. We keep upgrading our tools with new
            features that enhance your business functions and return high
            productivity and accuracy in the undertaken critical tasks.
          </p>
        </div>
      </div>
      <div class="row justify-content-center video-bg" id="onpassive">
        <div class="col-lg-9">
          <div class="video_box acc_panel"></div>
          <video
            id="my-video"
            class="video-js video-size w-100 h-auto"
            controls
            preload="auto"
            poster="{{ onPassiveBaseUrl }}onpassive(jan-23)/images/poster.png"
            data-setup="{}"
          >
            <source
              src="{{ myLinksS3URL }}videos/Onpassive_launching_page_video2.mp4"
              type="video/mp4"
            />
          </video>
        </div>
      </div>
    </div>
  </section>
  <section class="heart">
    <div class="container">
      <div class="bg-balls">
        <div class="col-12">
          <h2 class="text-center">
            Key Highlights of <br />
            What We Offer
          </h2>
        </div>
        <div class="row align-items-center mb-4">
          <div class="col-lg-7 order-lg-1 order-2">
            <h3>Business <span>Automation</span></h3>
            <p>
              Online companies have evolved drastically in the last few years
              with the help of technology, and there are many
              never-before-explored areas in the automation industry. This is
              where we step in to unite business with automation.
            </p>
            <p>
              We, at ONPASSIVE, are passionate about technology and how it can
              deliver the highest expected results in no time. That's why we
              embedded Artificial Intelligence (AI) in tools which take over
              manual activities and turn them into 100% complete automation. The
              outcome is unimaginable and easily measurable. The AI keeps
              identifying patterns across the internet and keeps generating
              areas of opportunities to take your business forward.
            </p>
          </div>
          <div class="col-lg-5 order-lg-2 order-1">
            <div class="thumb-block">
              <img
                src="{{ onPassiveBaseUrl }}onpassive(jan-23)/images/z1.png"
                alt="z1"
                class="img-fluid"
              />
            </div>
          </div>
        </div>
        <div class="row align-items-center mb-4">
          <div class="col-lg-7 order-2">
            <h3>Peer-to-Peer <span>Networking Platform</span></h3>
            <p>
              No business has ever flourished without a perfect team or a
              community. Members of a community are the unsung heroes of the
              actual struggle, and behind the scene, their contribution is
              immense.
            </p>
            <p>
              Since the business activities are all automated, ONPASSIVE
              provides an online community of great leaders, visionaries and
              collaborators who believe in sharing and contributing towards new
              ideas and innovations. This community allows you to think out of
              the box and doesn't let you stick to one business idea only.
            </p>
          </div>
          <div class="col-lg-5 order-1">
            <div class="thumb-block">
              <img
                src="{{ onPassiveBaseUrl }}onpassive(jan-23)/images/z2.png"
                alt="z2"
                class="img-fluid"
              />
            </div>
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col-lg-7 order-lg-1 order-2">
            <h3>Advertisement and <span>Promotions</span></h3>
            <p>
              A business doesn't exist if it doesn't promote its products and
              services. With thousands of options available out there, many find
              it challenging to identify which channel or tool suits best for
              advertising their products.
            </p>
            <p>
              At ONPASSIVE, there is no stone left unturned while thinking of
              creating opportunities. We brainstormed many ideas and suggestions
              and finally came up with solutions to automate advertisements and
              promotions. These tools identify the target audience, create buyer
              personas, identify websites where they hang out and monitor their
              interests to pitch your products on your behalf.
            </p>
          </div>
          <div class="col-lg-5 order-lg-2 order-1">
            <div class="thumb-block">
              <img
                src="{{ onPassiveBaseUrl }}onpassive(jan-23)/images/z3.png"
                alt="z3"
                class="img-fluid"
              />
            </div>
          </div>
        </div>
        <div class="row justify-content-center mt-5">
          <a
            href="/registration/user?reg={{ userId }}"
            target="_blank"
            rel="noopener"
            class="btn btn-danger px-5"
            >Join Us Now</a
          >
        </div>
      </div>
    </div>
  </section>
  <footer class="siter-footer text-center">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <p class="mb-0 text-uppercase">
            &copy; 2022 ONPASSIVE - All Rights Reserved
          </p>
        </div>
      </div>
    </div>
  </footer>
</body>
